var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    "data-name": "Capa 1",
    viewBox: "0 0 1045.47 305.89999",
    width: 1045.47,
    height: 305.89999,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill-rule:evenodd;}"))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 1045.47,153.15 c 0,88.91 -59.23,152.75 -146.37,152.75 -82.37,0 -143.6,-58.59 -143.6,-152.75 C 755.5,52 828.2,0 901.86,0 c 70.62,0 143.61,49.32 143.61,153.15 z m -71.29,0 c 0,-42.46 -20.54,-91.72 -73.89,-91.72 -48.4,0 -73.88,41.61 -73.88,91.72 0,56.32 31.41,91.74 73.88,91.74 53.35,0 73.88,-48.75 73.89,-91.74 z",
    id: "path6",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 729.39,278.1 C 711.94,289.77 675.26,305.63 625.22,305.63 526.89,305.63 478.3,237.78 478.3,154.9 478.3,61.59 544.3,0 630.61,0 c 42.73,0 70.16,7.13 94.47,19 L 700.17,76.5 C 681.62,68.74 660.25,64.16 634.9,64.16 c -62.35,0 -83.52,37.32 -83.52,88.83 0,55.6 28.4,91.66 77.89,91.66 17.92,0 31.37,-3.84 35.52,-6.53 v -51.69 h -50.24 l 0.07,-58.53 h 114.74 z",
    id: "path8",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m 393.56,300.79 a 231.12,231.12 0 0 0 -39.59,-80 C 342.6,206.14 333.75,203 333.75,203 c -9.18,0.25 -15.51,0.21 -23.93,-0.17 v 97.93 H 241.18 V 7.85 c 14.45,-2.33 24.82,-3.6 40,-5 14,-1.3 29.75,-2.15 47.25,-2.15 q 34.71,0 58.94,7.67 24.23,7.67 39.57,21 a 77.89,77.89 0 0 1 22.6,32 99.13,99.13 0 0 1 7.27,37.95 c 0,17.76 -4.34,35 -13.79,49.69 -8.39,13.07 -22.49,26.46 -37.08,35.66 V 186 c 32.61,14.92 51.08,63 69,114.8 z M 387.91,101 c 0,-12.38 -4.44,-22.3 -13.33,-29 -8.87,-7 -21.09,-10.43 -35.89,-10.66 -1.65,0 -8,0 -11.86,0.17 -3.86,0.17 -13.85,1 -17,1.59 v 84.4 c 4.58,0.54 14.07,1 21.8,1 16.42,0 31.69,-4.52 41.39,-12 9.68,-7.9 14.89,-20.41 14.89,-35.5 z",
    id: "path10",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M 0,230.66 V 4.84 h 201.58 l 0.05,63 h -133 v 50.66 h 112.56 l 0.07,59.77 H 68.65 v 31.66 c 0,19.89 11.69,28.3 26.92,28.3 h 111.49 l 0.08,62.58 H 69.62 C 18.12,300.78 0,277 0,230.66 Z",
    id: "path12",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgo);
export default __webpack_public_path__ + "static/media/ergo.c30c99f7c4ccc87df932c118dbc6296b.svg";
export { ForwardRef as ReactComponent };